import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

class AiStoriesChannelService {
  async list(search = '') {
    const params = search ? { search: search.trim() } : {};
    const response = await axios.get(`${API_BASE_URL}/ai-stories-channels`, { params });
    return response.data;
  }

  async get(id) {
    const response = await axios.get(`${API_BASE_URL}/ai-stories-channels/${id}`);
    return response.data;
  }

  async create({ name, profileNumber, color, voiceOverConfigId, footageFolderId, automation }) {
    const body = {
      voiceOverConfigId,
      footageFolderId,
      automation,
      name: name.trim(),
      profileNumber: typeof profileNumber === 'number' ? profileNumber : parseInt(profileNumber, 10),
    };
    if (color !== undefined && color !== null) body.color = typeof color === 'string' ? color.trim() : '';
    const response = await axios.post(`${API_BASE_URL}/ai-stories-channels`, body);
    return response.data;
  }

  async update(id, { name, profileNumber, color, voiceOverConfigId, footageFolderId, automation }) {
    const payload = { voiceOverConfigId, footageFolderId, automation };
    if (name !== undefined) payload.name = name.trim();
    if (profileNumber !== undefined) {
      payload.profileNumber =
        typeof profileNumber === 'number' ? profileNumber : parseInt(profileNumber, 10);
    }
    if (color !== undefined) payload.color = typeof color === 'string' ? color.trim() : '';
    const response = await axios.put(`${API_BASE_URL}/ai-stories-channels/${id}`, payload);
    return response.data;
  }

  async getAutomation(id) {
    const response = await axios.get(`${API_BASE_URL}/ai-stories-channels/${id}/automation`);
    return response.data;
  }

  async runAutomation(id) {
    const response = await axios.post(`${API_BASE_URL}/ai-stories-channels/${id}/automation/run`);
    return response.data;
  }

  async delete(id) {
    await axios.delete(`${API_BASE_URL}/ai-stories-channels/${id}`);
  }
}

export default new AiStoriesChannelService();
